<template id="view-HolyDays">
  <!-- :class="{ 'container-fluid': isMobile, container: !isMobile }" -->
  <div class="container-fluid">
    <div class="row top-row">
      <div class="col-12">
        <h3>Días Festivos / No Laborables</h3>
      </div>
    </div>
    <div class="row">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 offset-xl-2 card "
        style="padding: 20px;"
      >
        <!-- HolyDays -->
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <center>
              <!--  -->
              <ejs-calendar
                id="calendar"
                @change="calendarChanged"
                @navigated="calendarNavigated"
                :renderDayCell="renderCalendar"
                ref="objCalendar"
              ></ejs-calendar>
            </center>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <div class="e-card">
              <div class="e-card-header">
                <div class="e-card-header-image football"></div>
                <div class="e-card-header-caption">
                  <div class="e-card-header-title">
                    {{ this.currentStringDate }}
                  </div>
                  <div class="e-card-sub-title">
                    {{ selectedDay.description }}
                  </div>
                </div>
              </div>
              <div class="e-card-content">
                <div class="row">
                  <div class="col-xs-12 col-sm-12" style="margin-bottom: 20px;">
                    <ejs-textbox
                      floatLabelType="Auto"
                      v-model="selectedDay.description"
                      :readonly="!showSaveButton"
                      :cssClass="
                        hasError('description')
                          ? 'e-outline e-warning'
                          : 'e-outline'
                      "
                      placeholder="Descripción / Celebración"
                      @input="validate()"
                      @blur="validate()"
                    ></ejs-textbox>
                    <span
                      class="help e-text small"
                      :class="{ 'e-warning': hasError('description') }"
                      v-text="m_errors.description"
                    >
                    </span>
                  </div>

                  <div class="col-xs-12 col-sm-12 ">
                    <div class="e-btn-group e-outline">
                      <ejs-button
                        @click.native="saveHoliday"
                        :isPrimary="true"
                        iconCss="e-icons icon-save inline-command"
                        cssClass="e-flat e-noback"
                        v-if="showSaveButton"
                        >Grabar</ejs-button
                      >
                      <ejs-button
                        @click.native="deleteHoliday"
                        :isDanger="true"
                        iconCss="e-icons icon-trash inline-command"
                        cssClass="e-flat e-danger e-noback"
                        v-if="showDeleteButton"
                        >Eliminar</ejs-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*Imports de VueJS*/
import Vue from "vue";

import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
import CultureMixin from "../../mixins/CultureMixin";

/*Imports de Syncfusion*/
import { Browser } from "@syncfusion/ej2-base";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { CalendarPlugin } from "@syncfusion/ej2-vue-calendars";
import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { DialogUtility } from "@syncfusion/ej2-popups";

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

Vue.use(TextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(CalendarPlugin);

export default Vue.extend({
  name: "HolyDays",
  props: {},
  components: {},
  mixins: [PermissionMixin, ToastMixin, CultureMixin],
  created() {},
  async mounted() {
    try {
      this.$parent.showLoading();
      var year = this.currentYear;
      this.selectedYear = year;
      this.currentDate = new Date();
      await this.loadYearData(year);
      this.$parent.hideLoading(500);
    } catch (error) {
      this.showToast("Error", "Error cargando los días festivos.!", 200);
      this.$parent.hideLoading(500);
    }
  },
  updated() {
    //this.$refs.objCalendar.ej2Instances.refresh();
  },
  computed: {
    showDeleteButton() {
      return this.hasPermission("CanDelete") && this.selectedDay.id > 0;
    },

    showSaveButton() {
      var perm =
        this.hasPermission("CanCreate") ||
        (this.hasPermission("CanEdit") && this.selectedDay.id > 0);
      return perm;
    },
    isMobile() {
      return Browser.isDevice();
    },
    canDelete() {
      if (!this.hasPermission("CanDelete")) {
        return false;
      }
      return true;
    },
    currentYear() {
      var d = new Date();
      var year = d.getFullYear();
      return year;
    }
  },
  data() {
    return {
      /* Datos del Grid */
      currentDate: null,
      currentStringDate: "No Seleccionado",
      celebration: "",
      AlreadySaved: false,
      selectedDay: {},
      m_errors: {},
      selectedYear: 0
    };
  },
  methods: {
    async loadYearData(year) {
      this.selectedYear = year;
      await this.$store.dispatch("calendars/getHolidays", year);
      this.holidays = JSON.parse(
        JSON.stringify(this.$store.getters["calendars/allHolidays"])
      );
      this.reactToChange();
      this.$refs.objCalendar.ej2Instances.refresh();
    },
    async saveHoliday() {
      var isValid = this.validate();
      if (!isValid) return;

      try {
        this.$parent.showLoading();
        var created = false;

        if (this.selectedDay.id > 0) {
          created = await this.$store.dispatch(
            "calendars/updateHoliday",
            this.selectedDay
          );
        } else {
          created = await this.$store.dispatch(
            "calendars/createHoliday",
            this.selectedDay
          );
        }

        if (created) {
          var d = new Date();
          var year = d.getFullYear();

          this.showToast("Creado", "Día registrado exitosamente", 2000);
          await this.$store.dispatch("calendars/getHolidays", year);
          this.holidays = JSON.parse(
            JSON.stringify(this.$store.getters["calendars/allHolidays"])
          );
          this.$refs.objCalendar.ej2Instances.value = this.selectedDay.holyDay;
          this.$refs.objCalendar.ej2Instances.refresh();
          this.reactToChange();
          this.$forceUpdate();
        } else {
          this.showToast("Oops", "Ocurrió un error al registrar el día", 2000);
        }

        this.$parent.hideLoading(500);
      } catch (error) {
        this.showToast(
          "Error",
          `Error grabando el día festivo! ${error}`,
          2000
        );
        this.$parent.hideLoading(500);
      }
    },
    async deleteHoliday() {
      var isValid = this.validate();
      if (!isValid) return;
      try {
        this.$parent.showLoading();
        var deleted = false;

        if (this.selectedDay.id > 0) {
          deleted = await this.$store.dispatch(
            "calendars/deleteHoliday",
            this.selectedDay
          );
        }

        if (deleted) {
          var d = new Date();
          var year = d.getFullYear();

          this.showToast("Completado", "Día eliminado exitosamente", 2000);
          await this.$store.dispatch("calendars/getHolidays", year);
          this.holidays = JSON.parse(
            JSON.stringify(this.$store.getters["calendars/allHolidays"])
          );

          this.currentDate = new Date();
          this.selectedDay = {
            id: 0,
            description: "",
            holyDay: d
          };

          this.$refs.objCalendar.ej2Instances.refresh();

          this.reactToChange();
          this.$forceUpdate();
        } else {
          this.showToast("Oops", "Ocurrió un error al eliminar el día", 2000);
        }

        this.$parent.hideLoading(500);
      } catch (error) {
        this.showToast(
          "Error",
          `Error grabando el día festivo! ${error}`,
          2000
        );
        this.$parent.hideLoading(500);
      }
    },
    validate() {
      this.validationSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        description: Yup.string()
          .required()
          .max(50)
          .label("Fecha especial")
      });

      Vue.set(this.m_errors, "description", "");
      var hasErrors = false;
      this.validationSchema
        .validateAt("description", this.selectedDay)
        .catch(err => {
          Vue.set(this.m_errors, err.path, err.message);
        });
      if (hasErrors) return false;

      var pattern = /[/,:;'{}\x22\\]/;
      var strData = this.selectedDay.description;
      //var regEx = new RegExp(pattern);
      var hasSpecial = strData.match(pattern) ? true : false;
      if (hasSpecial) {
        Vue.set(
          this.m_errors,
          "description",
          "La descripción tiene caracteres no permitidos"
        );
        // this.showToast(

        //   "No se puede grabar, la descripción tiene caracteres no permitidos"
        // );
        return false;
      }

      return true;
    },
    async calendarNavigated(args) {
      var oldYear = this.selectedYear;
      var newYear = oldYear;
      if (args.name == "navigated") {
        var date = args.date;
        newYear = date.getFullYear();
        oldYear = this.selectedYear;
        this.currentDate = date;
        this.reactToChange();
        this.$refs.objCalendar.ej2Instances.value = this.currentDate;

        if (args.view == "Month") {
          if (oldYear != newYear) {
            try {
              this.$parent.showLoading();

              await this.loadYearData(newYear);

              this.$parent.hideLoading(500);
            } catch (error) {
              this.$parent.hideLoading(500);
              this.showToast("error", error, 2000);
            }
          }
        }
      }
    },
    hasError(field) {
      return !!this.m_errors[field];
    },
    reactToChange() {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };

      this.currentStringDate = this.currentDate.toLocaleDateString(
        "es-CO",
        options
      );

      var found = this.findHolyDay(this.currentDate);
      if (found != null) {
        this.selectedDay = JSON.parse(JSON.stringify(found));
      } else {
        this.selectedDay = {
          id: 0,
          description: "",
          holyDay: this.currentDate
        };
      }
    },
    calendarChanged(args) {
      this.currentDate = new Date(args.value);
      this.reactToChange();
    },
    getDeleteConfirmation() {
      this.deleteDialog = DialogUtility.confirm({
        title: "Eliminar Fecha",
        zindex: 1010,
        content: `Confirma que desea eliminar el festivo: ${this.selectedDay.description}`,
        okButton: {
          text: "Eliminar",
          click: this.DeleteHoliday,
          isPrimary: true
        },

        cancelButton: { text: "Cancelar" },
        showCloseIcon: false,
        closeOnEscape: false,
        animationSettings: { effect: "Zoom" }
      });
      this.deleteDialog.show();
    },
    findHolyDay(date) {
      try {
        var dateSearched = date.toISOString();
        var valSearched = dateSearched.substring(0, 10);
        /*
        var dateNew = Date(date);
        console.log(dateNew.toisoString());
        */
        if (this.holidays == undefined) return null;

        var dateFound = this.holidays.find(el => {
          var holyDate = el.holyDay;
          var holySearch = holyDate.substring(0, 10);
          return holySearch == valSearched;
        });

        return dateFound;
        // if (dateFound != null) {
        //   return "Encontré la fecha: " + JSON.stringify(dateFound);
        // }
      } catch (error) {
        console.log(error);
      }

      return "";
    },
    renderCalendar(args) {
      //validar si los dias del calendario están marcados como festivos.
      //var stringDate = args.date.toISOString();
      //console.log(args);
      //console.log(args.element.classList);

      if (args.element.classList.value.includes("e-other-month")) {
        args.isDisabled = true;
        //args.element.classList.add("e-month-hide");
      }

      var hasDay = this.findHolyDay(args.date);
      if (hasDay != null) {
        args.element.classList.add("e-highlightspecial");
      } else if (args.date.getDay() === 0 || args.date.getDay() === 6) {
        // To highlight the week end of every month
        args.element.classList.add("e-highlightweekend");
      }
    }
  }
});
</script>
<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-layouts/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-inputs/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-popups/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-inputs/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-splitbuttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-lists/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-popups/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-calendars/styles/fabric.css);
@import url(../form-icons.css);

/*
@import url(../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css);
*/
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);

.e-highlightweekend {
  background-color: #cccccc;
}

.e-calendar .e-content td.e-selected {
  background-color: #0078d6;
}

.e-highlightspecial {
  background-color: darkslategray;
  color: white !important;
}

.e-highlightspecial .e-day {
  color: white !important;
}

.e-cell.e-highlightspecial.e-today.e-selected .e-day {
  background-color: #0078d6 !important;
}

.e-cell.e-highlightspecial.e-today.e-focused-date .e-day {
  background-color: darkslategray !important;
}

.e-cell.e-highlightspecial.e-today .e-day {
  background-color: darkslategray !important;
}

.e-cell.e-highlightspecial.e-today.e-focused-date .e-day {
  background-color: darkslategray !important;
}

.e-highlightspecial .e-day:hover {
  color: white !important;
  background-color: transparent !important;
}

.e-alert-dialog.e-dialog.e-popup,
.e-confirm-dialog.e-dialog.e-popup {
  margin: auto !important;
}
/*
.e-save.e-icons:before,
.e-icons.icon-save:before {
  content: "\e609";
}
*/
.content-wrapper {
  width: 100%;
  margin: 15px auto;
  min-width: 185px;
}
@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
}
</style>
